import React from 'react';
import { createRoot } from 'react-dom/client';
import { JobBoardViewNav } from './JobBoardViewNav';
import './styles.css';
const container = document.getElementById('job-board-view');

if (container) {
  const root = createRoot(container);
  root.render(
      <JobBoardViewNav />
  );
} else {
  console.error('Error: El contenedor raíz para la aplicación React no fue encontrado.');
}
